import { Link } from "@tanstack/react-router";
import type { CatalogProduct } from "@/lib/catalog/products";
import { ProductCard } from "@/components/home/ProductCard";
import { formatINR } from "@/lib/pdp/product-helpers";
import { startingPrice } from "@/lib/catalog/size-pricing";

export function RelatedProducts({
  title,
  eyebrow,
  products,
}: {
  title: string;
  eyebrow: string;
  products: CatalogProduct[];
}) {
  if (products.length === 0) return null;
  return (
    <section
      className="border-t border-black/10 bg-white py-16 lg:py-24"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-10">
          <span className="text-[11px] font-medium uppercase tracking-[0.32em] text-[#C6A15B]">
            {eyebrow}
          </span>
          <h2
            className="mt-3 text-3xl font-normal text-black sm:text-4xl"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {title}
          </h2>
          <div className="mt-4 h-px w-10 bg-[#C6A15B]" />
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-4 lg:gap-x-8">
          {products.map((p) => (
            <Link
              key={p.id}
              to="/fragrances/$slug"
              params={{ slug: p.slug }}
              className="block outline-none focus-visible:ring-2 focus-visible:ring-[#C6A15B]"
            >
              <ProductCard
                product={{
                  id: p.id,
                  slug: p.slug,
                  name: p.name,
                  family: p.family,
                  notes: p.notes,
                  price: `Starting From ${formatINR(startingPrice(p))}`,
                  img: p.img,
                  badge: p.badge,
                }}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
